import(/* webpackMode: "eager", webpackExports: ["ApexLegendIcon"] */ "/vercel/path0/components/ApexLegendIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ApexStats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/FortniteStats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/LoLStats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlayScheduleViewed"] */ "/vercel/path0/components/play-schedule/PlayScheduleViewed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ProfileClips.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/RequestMatchButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AvatarGroup"] */ "/vercel/path0/components/shadcnblocks/avatar-group.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/SocialLinks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TournamentHistoryInline"] */ "/vercel/path0/components/tournament-history/TournamentHistoryInline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/vercel/path0/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GpBadge"] */ "/vercel/path0/components/ui/gp-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.4.10_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.4.10_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
